<div cdkDrag
     [cdkDragDisabled]="!draggable"
     [cdkDragRootElement]="dragRootSelector">
  <ng-template #vc></ng-template>
</div>
